import { render, staticRenderFns } from "./addToQuote.vue?vue&type=template&id=f8565356&"
import script from "./addToQuote.vue?vue&type=script&lang=js&"
export * from "./addToQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports